import React, { Component } from 'react';
import Highcharts from 'highcharts/highstock'
import HighchartsReact from 'highcharts-react-official'
import { withRouter } from 'react-router-dom';
//import queryString from 'query-string';

import {api_host, api_auth} from '../../../../../common/globals/constants';
import CircularProgress from '@material-ui/core/CircularProgress';

import moment from 'moment'
import 'moment/locale/es'  

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';

import Typography from '@material-ui/core/Typography';
import PerfectScrollbar from 'react-perfect-scrollbar';
import compose from 'recompose/compose';
import { useTranslation, withTranslation } from 'react-i18next';
import { reportFetchError } from '../../../../../observability/rum';

moment.locale('es')
class CumulativeFrecuency extends Component {

    constructor(props) {
        super(props);
        // Referencia al componente del gráfico (compatible desde React 16.3+)
        this.chartComponentRef = React.createRef();

        // Vincular el método a la clase
        this.toggleAllSeries = this.toggleAllSeries.bind(this);
        this.state = {
            currentObjectiveId: this.props.match.params.objetivo_id,
            prevObjectiveId: this.props.match.params.objetivo_id,
            loadObjectiveData: false,
            externalData: null,
            dataError: false,
            isLoading: true,
            sla: null,
            time: 'h',
            hoverData: null,
            lastEvent: [],
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            chartOptionsBase: this._chartOptionsBase(),
            chartOptions: this._chartOptionsBase(),
            isRefresh: this.props.params.isRefresh,
            date: this.props.params.date,
            dateMoment:((moment().locale('es')).format("dddd, DD/MM/YYYY, h:mm:ss a")),
            allVisible:true
        }
    }

    _chartOptionsBase = () => {
        const t = this.props.t;
        const self = this;
        return {
        chart: {
            type: 'spline',
            zoomType: 'x',
            ignoreHiddenSeries: false,
            marginRight: 30,
            resetZoomButton: {
                theme: {
                    fill: 'white',
                    stroke: 'silver',
                    r: 0,
                    states: {
                        hover: {
                            fill: '#41739D',
                            style: {
                                color: 'white'
                            }
                        }
                    }
                }
            },
            events: {
                render: function () {
                    const chartContainer = this.container;
                    const btn = chartContainer.querySelector('.toggle-series-btn');
                    if (btn && !btn.dataset.hasListener) {
                        btn.dataset.hasListener = 'true';
                        btn.addEventListener('click', (e) => {
                            e.stopPropagation();
                            self.toggleAllSeries();
                        });
                    }
                }
            }
        },
        title: {
            text: "",
            style: {
                fontSize: '' 
             }
        },
        /*subtitle: {
            text: 'Hola'
        },*/
        subtitle: {
            text: '',
            style: {
                color: '',
                fontWeight: ''
            }
        },
        xAxis: {
            min: 0,
            title: {
                text: t('cumulative-frequency.graph.xAxis.title.text')
            },
            /*title: {
                useHTML:true,
                style: { color: '#5A5A5A', fontSize: '12px', fontWeight: 'bold' },
                text: '<br/>Período'
            },	*/
            labels: {
                useHTML: true,
            },
        },
        yAxis: {
            min: 0,
            title: {
                text: t('cumulative-frequency.graph.yAxis.title.text')
            },
            plotLines: []
        },
        setOptions: {
            time: {
                useUTC: false
            },
            lang: {
                months: t('months', { returnObjects: true }),
                weekdays: t('weekDays', { returnObjects: true }),
            }
        },
        plotOptions: {
            series: {
                turboThreshold: 20000,
                //gapSize: 2,
                marker: {
                    symbol: 'circle',
                    width: 8,
                    height: 8,
                    enabled: false
                },
            },

        },

        legend: {
            enabled: true,
            useHTML: true,
            symbolWidth: 0,labelFormatter: function() {
                let symbol = '<div style="background:' + this.color + ';width:15px;height:3px;margin-top:5px"></div>'
                let name= '<button style="padding-left:4px;border-width:0px;background:white">'+this.name+'</button>'
                return '<div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;">' + symbol + ' ' + name + '</div>'
              }
        },

        tooltip: {
            enabled: true,
            
        },
        credits: {
            enabled: false
        },
        series: []

    }
    }

    setHoverData = (e) => {
        const { x, y, series } = e.target
        // The chart is not updated because `chartOptions` has not changed.
        let point = []
        point['x'] = y
        point['y'] = x
        let step = series.userOptions.name
        this.props.params.onInfo(point, step)
    }

    static getDerivedStateFromProps(props, state) {
        if (props.match.params.objetivo_id !== state.prevObjectiveId) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
            }
        } else if (props.params.period !== state.time) {
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if ((props.params.period === state.time) && (props.params.statePeriod !== state.statePeriod)) {
            return {
                chartOptions: state.chartOptionsBase,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                hoverData: null,
                isLoading: true,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isStatePeriod: props.params.isStatePeriod
            }
        } else if(props.params.isRefresh !== state.isRefresh){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                isRefresh: props.params.isRefresh,          
            }

        }else if(props.params.date !== state.date){
            return {
                chartOptions: state.chartOptionsBase,
                externalData: null,
                prevObjectiveId: props.match.params.objetivo_id,
                time: props.params.period,
                dataError: false,
                isLoading: true,
                hoverData: null,
                lastEvent: [],
                statePeriod: props.params.statePeriod,
                date: props.params.date,          
            }

        }
        return null;
    }

    componentDidMount() {
        this.getDataFromAPI();
    }

    componentDidUpdate(prevProps, prevState) {
        if((prevProps.params.isRefresh !== this.state.isRefresh) && this.state.dateMoment!==((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a"))){
            this.props.params.onDateMoment(((moment().locale('es')).format("dddd, MMMM YYYY, h:mm:ss a")))
        }
        if ((prevProps.params.period !== this.state.time) ||
            (prevProps.match.params.objetivo_id !== this.props.match.params.objetivo_id) ||
            (prevProps.params.statePeriod !== this.state.statePeriod) ||
            (prevProps.params.isRefresh !== this.state.isRefresh)||
            (prevProps.params.date !== this.state.date)) {
            this.getDataFromAPI();
        }

    }
    componentWillUnmount() {

    }

    getDataFromAPI = (objectiveId) => {
        const { objetivo_id } = this.props.match.params
        const { fromObjective } = this.props.location.state
        const { period, statePeriod, schedule } = this.props.params
        const { history } = this.props

        let sla_rendimiento_ok = parseInt(fromObjective.sla_rendimiento_ok)
        let sla_rendimiento_error = parseInt(fromObjective.sla_rendimiento_error)
        let sla_disponibilidad_ok = parseInt(fromObjective.sla_disponibilidad_ok)
        let sla_disponibilidad_error = parseInt(fromObjective.sla_disponibilidad_error)
        let fecha_inicio = null
        let fecha_termino = null
        let token = sessionStorage.getItem('key')
        if (period === 'c') {
            fecha_inicio = statePeriod.startDate.toISOString().substring(0, 10)
            fecha_termino = statePeriod.endDate.toISOString().substring(0, 10)
            fetch(api_host+`/reporte/online/indicadores/getFrecuenciaRendimientoGlobalObjetivoCustom/?objetivoId=${objetivo_id}&token=${token}&fechaInicio=${fecha_inicio}&fechaTermino=${fecha_termino}&horarioId=${schedule}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('HTTP error ' + response.status);
                    }
                    return response.json();
                })
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                        this.setState({ dataError: true, data: null, isLoading: false });
                    } else {
                    //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }
                })
                .catch(error => {
                    reportFetchError('CumulativeFrecuency', error);
                    this.setState({ dataError: true, data: null, isLoading: false });
                });
        } else {
            fetch(api_host+`/reporte/online/indicadores/getFrecuenciaRendimientoGlobalObjetivo/?objetivoId=${objetivo_id}&token=${token}&key=07374CEAC2EAEF2EB3441BA0C433F9834E6CF6E2&horarioId=0&t=${period}`)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('HTTP error ' + response.status);
                    }
                    return response.json();
                })
                .then(myJson => {
                    // Se define el state de acuerdo a la petición y respuesta de la promesa 
                    if (myJson.status == 1 || myJson.status == 5) {
                        localStorage.setItem('isAuthenticated', false);
                        this.setState({ dataError: true, data: null, isLoading: false });
                    } else {
                        //Procesa la Data Recibida
                        try {
                            this.processData(myJson, sla_rendimiento_ok,
                                sla_rendimiento_error,
                                sla_disponibilidad_ok,
                                sla_disponibilidad_error,
                                period,
                                fecha_inicio,
                                fecha_termino)
                            if (this.state.lastEvent && this.state.lastEvent.length > 0) {
                                this.props.params.onFirstInfo(this.state.lastEvent)
                            }
                        } catch (error) {
                            this.setState({
                                dataError: true,
                                data: null,
                                isLoading: false
                            });
                        }
                    }

                })
                .catch(error => {
                    reportFetchError('CumulativeFrecuency', error);
                    this.setState({ dataError: true, data: null, isLoading: false });
                });

        }
    }

    // Helper para procesar la data de la petición a la API

    processData = (externalData,
        sla_rendimiento_ok,
        sla_rendimiento_error,
        sla_disponibilidad_ok,
        sla_disponibilidad_error,
        period,
        fecha_inicio,
        fecha_termino) => {
        let arrayChartData = []
        let lastEventDict = []
        
        const colors = ['#2199e8', '#fed12d', '#ff7373', '#ccff00', '#b6fcd5',
            '#065535', '#ffc0cb', '#008080', '#00ffff', '#ffa500',
            '#800000', '#fff68f', '#bada55', '#8a2be2', '#3b5998'];
        
        const t = this.props.t;
        Object.keys(externalData.Objetivo.Paso).map((key) => {
            let chartDataSeries = {}
            let arrayData = []
            var cumulativeElements = 0
            let rowLen = externalData.Objetivo.Paso[key].rendimientoDetalle.length;

            externalData.Objetivo.Paso[key].rendimientoDetalle.forEach((item, forEachKey) => {
                var dict = {};
                cumulativeElements = cumulativeElements + item.elementos
                dict['y'] = cumulativeElements
                dict['x'] = item.respuesta
                arrayData.push(dict)
                if (forEachKey == (rowLen - 1) && key == 0) {
                    lastEventDict['x'] = dict['y']
                    lastEventDict['y'] = dict['x']
                    lastEventDict['name'] = externalData.Objetivo.Paso[key].paso_nombre;
                    if (period === 'h') {
                        lastEventDict['namePeriod'] = `${t('text.range')}: ${t('text.last-3-hours')}`
                    } else if (period === 'd') {
                        lastEventDict['namePeriod'] = `${t('text.range')}: ${t('text.last-day')}`
                    } else if (period === 'w') {
                        lastEventDict['namePeriod'] = `${t('text.range')}: ${t('text.last-week')}`
                    } else if (period === 'c') {
                        lastEventDict['namePeriod'] = `${t('text.range')}: ${fecha_inicio} ${t('text.to2')} ${fecha_termino}`
                    }
                }
            });
            chartDataSeries['name'] = externalData.Objetivo.Paso[key].paso_nombre;
            chartDataSeries['color'] = colors[key]
            chartDataSeries['data'] = arrayData
            arrayChartData.push(chartDataSeries)
        })
        this.setState({
            chartOptions: {
                xAxis: {
                    plotLines: [{
                        value: sla_rendimiento_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_rendimiento_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }]
                },
                plotOptions: {
                    series: {
                        point: {
                            events: {
                                mouseOver: this.setHoverData.bind(this)
                            }
                        },
                        events: {
                            legendItemClick: () => {
                                setTimeout(() => {
                                    this.checkAllVisible();
                                }, 10);
                            }
                        },
                    }
                },
                series:
                    arrayChartData,
                legend: {
                    enabled: true,
                    useHTML: true,
                    title: {
                        text: `<div style="display: flex; justify-content: flex-end; margin-bottom: 8px;">
                                <button class="toggle-series-btn" style="color: #333333; font-size: 11px; padding: 4px 8px; cursor: pointer; border: 1px solid #cccccc; background: #ffffff; border-radius: 4px;">
                                    ${this.state.allVisible ? t('text.hide-step') : t('text.show-step')}
                                </button>
                               </div>`,
                        style: {
                            fontWeight: 'normal'
                        }
                    },
                    labelFormatter: function() {
                        // 'this.visible' indica si la serie está visible o no
                        const isVisible = this.visible;
                
                        // Ajustamos la opacidad y los colores según la visibilidad
                        const opacity = isVisible ? '1' : '0.65';
                        const textColor = isVisible ? '#333333' : '#666666';
                        const lineThrough = isVisible ? 'none' : 'line-through';
                
                        let symbol = `<div style="background:${this.color};width:15px;height:3px;margin-top:5px;opacity:${opacity};"></div>`;
                        let name = `<button style="padding-left:4px;border-width:0px;background:transparent;color:${textColor};text-decoration:${lineThrough};opacity:${opacity};cursor:pointer;">${this.name}</button>`;
                
                        return `<div style="display: flex;flex-direction: row;flex-wrap: nowrap;justify-content: space-between;opacity:${opacity};">${symbol} ${name}</div>`;
                    }
                },
            },
            dataError: false,
            isLoading: false,
            lastEvent: lastEventDict,
            time: period,
            chartOptionsBase: {
                ...this._chartOptionsBase(),
                xAxis: {
                    ...this._chartOptionsBase().xAxis,
                    plotLines: [{
                        value: sla_rendimiento_ok,
                        color: '#54a51c',
                        width: 2,
                        zIndex: 3
                    }, {
                        value: sla_rendimiento_error,
                        color: '#D22129',
                        width: 2,
                        zIndex: 3
                    }]
                },
                series: arrayChartData
            }
        });

    }

    toggleAllSeries() {
        const chart = this.chartComponentRef.current?.chart || this.chartComponentRef?.chart;
        if (!chart) return;
    
        const nextState = !this.state.allVisible;
        const t = this.props.t;
    
        // 1. Ocultar o mostrar todas las series sin redibujar inmediatamente
        chart.series.forEach((series) => {
            if (nextState) {
                series.show(false);
            } else {
                series.hide(false);
            }
        });
        // 2. Actualizar el estado y el texto del botón dentro del título de la leyenda
        this.setState({ allVisible: nextState }, () => {
            chart.update({
                legend: {
                    title: {
                        text: `<div style="display: flex; justify-content: flex-end; margin-bottom: 8px;">
                               <button class="toggle-series-btn" style="color: #333333; font-size: 11px; padding: 4px 8px; cursor: pointer; border: 1px solid #cccccc; background: #ffffff; border-radius: 4px;">
                                   ${nextState ? t('text.hide-step') : t('text.show-step')}
                               </button>
                              </div>`
                    }
                }
            });
        });
    }
    
    checkAllVisible() {
        const chart = this.chartComponentRef.current?.chart || this.chartComponentRef?.chart;
        if (!chart) return;
    
        const isAnyVisible = chart.series.some(series => series.visible);
    
        if (this.state.allVisible !== isAnyVisible) {
            const t = this.props.t;
            this.setState({ allVisible: isAnyVisible }, () => {
                chart.update({
                    legend: {
                        title: {
                            text: `<div style="display: flex; justify-content: flex-end; margin-bottom: 8px;">
                                   <button class="toggle-series-btn" style="color: #333333; font-size: 11px; padding: 4px 8px; cursor: pointer; border: 1px solid #cccccc; background: #ffffff; border-radius: 4px;">
                                       ${isAnyVisible ? t('text.hide-step') : t('text.show-step')}
                                   </button>
                                  </div>`
                        }
                    }
                });
            });
        }
    }


    render() {
        const { dataError, chartOptions, isLoading,chartOptionsBase,allVisible} = this.state;
        const style = isLoading ? { display: 'none' } : {};
        const styleHidden = isLoading ? {} : { display: 'none' };
        const t = this.props.t;
        if (!dataError) {
            sessionStorage.setItem("chartCumulativeFrecuency",JSON.stringify(chartOptionsBase))
            return (<FormattedChart chartOptions={chartOptions} style={style} styleHidden={styleHidden} allVisible={allVisible} toggleAllSeries={this.toggleAllSeries} chartRef={this.chartComponentRef} t={t}/>)
        }
        else if (dataError) {
            return (<p>{t('text.no-data')}</p>)
        }
        else return (<p>{t('cumulative-frequency.error')}</p>)

    }
}

function FormattedChart(props) {
    const { t } = useTranslation();
    return (
        <div >
            <div style={props.styleHidden}>
                <PortletContent>
                    <PerfectScrollbar>
                        <Typography
                            variant="h5"
                            >
                            <CircularProgress
                            variant="indeterminate"
                            size={24}
                            thickness={4}                            
                            />
                            <br/>
                            {t('text.loading')}
                        </Typography>
                    </PerfectScrollbar>
                </PortletContent>
            </div>
            <div style={props.style}>
                <HighchartsReact
                    ref={props.chartRef}
                    highcharts={Highcharts}
                    options={props.chartOptions} />
            </div>
        </div>
    )
}


export default compose(withRouter, withTranslation())(CumulativeFrecuency);